import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default () => {
  // (() => {
  //   const swiper = new Swiper('.js-profileSwiper', {
  //     // configure Swiper to use modules
  //     modules: [Pagination, Navigation],
  //     slidesPerView: 'auto',
  //     spaceBetween: 16,
  //     pagination: {
  //     el: '.swiper_buttons_pagination',
  //       clickable: true,
  //       dynamicBullets: true,
  //       dynamicMainBullets: 4,
  //     },
  //     navigation: {
  //       nextEl: ".swiper_buttons_next",
  //       prevEl: ".swiper_buttons_prev",
  //     },
  //   });
  // })();
}